import React, { Component } from 'react';

import { Form, Label, Radio, Input, Button } from '../../Form';

class Personal extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: false
    };
  }

  render() {
    const { isValid } = this.state;
    const { data, translate } = this.props;

    return (
      <Form
        ref={form => (this.form = form)}
        onValidationChange={valid => this.setState({ isValid: valid })}
        onSubmit={({ body }) => this.props.store(body)}
      >
        <Label text={translate('register.personal.salutation')} />
        <Radio
          name="salutation"
          rules={['required']}
          data={[
            {
              value: 'M',
              label: translate('register.personal.sir'),
              checked: data.salutation === 'M'
            },
            {
              value: 'F',
              label: translate('register.personal.madam'),
              checked: data.salutation === 'F'
            }
          ]}
        />

        <Label text={translate('register.personal.first_name')} />
        <Input name="first_name" rules={['required']} defaultValue={data.first_name} />

        <Label text={translate('register.personal.last_name')} />
        <Input name="last_name" rules={['required']} defaultValue={data.last_name} />

        <Label text="RIZIV-nr" />
        <Input name="riziv_number" rules={['required']} defaultValue={data.riziv_number} />

        <Button solid className="Form__Button" disabled={!isValid}>
          {translate('register.next')}
        </Button>
      </Form>
    );
  }
}

export default Personal;
